<script setup lang="ts">
import type { AlbumType } from '@/composables/album/album'
import { nextTick, onMounted, ref, watchEffect, type Ref } from 'vue'
import { useI18n } from 'vue-i18n'
import 'animate.css'

const { t } = useI18n()

// script setup
const model = defineModel<string>({ default: 'waterfall' })

interface AlbumOption {
  key: string
  name: string
  icon: string
}

const AlbumOptions: Ref<Array<AlbumOption>> = ref([
  { key: 'waterfall', name: t('album.waterfall_title'), icon: 'i-icon-park-solid:waterfalls-h' },
  { key: 'album', name: t('album.album_title'), icon: 'i-material-symbols:perm-media-outline-rounded' },
  { key: 'timeline', name: t('album.timeline_title'), icon: 'i-bx:sort-up' }
])

// 新增元素引用
const activeBackground = ref<HTMLElement>()
const optionElements = ref<HTMLElement[]>([])

onMounted(() => {
  setTimeout(() => {
    relocate(AlbumOptions.value.findIndex((opt) => opt.key === model.value))
  }, 100)
})

// 监听 model 变化更新背景位置
watchEffect(() => {
  const index = AlbumOptions.value.findIndex((opt) => opt.key === model.value)
  setTimeout(() => {
    relocate(index)
  }, 50)
})

function relocate(index: number = 0) {
  console.log('onRelocate:', index, model.value)
  nextTick(() => {
    const target = optionElements.value[index]
    if (target && activeBackground.value) {
      // 添加1px容差补偿边框
      const { offsetLeft: left, offsetWidth: width } = target
      activeBackground.value.style.transform = `translateX(${left}px)`
      activeBackground.value.style.width = `${width - 3}px`
    }
  })
}
</script>

<template>
  <div
    relative
    bg-transparent
    rounded-full
    border
    border-1px
    border-theme-dark
    class="border-theme-main"
    flex="~ row"
    items-center
    h-36px
    select-none
    justify-center
    overflow-hidden>
    <!-- 滑动背景 -->
    <div
      ref="activeBackground"
      absolute
      left-1px
      top-1px
      h-32px
      class="bg-theme"
      rounded-full
      transition-all
      duration-300
      ease-out
      style="z-index: 0"></div>
    <div
      v-for="(item, index) in AlbumOptions"
      :ref="(el) => (optionElements[index] = el as HTMLElement)"
      :key="item.key"
      flex="~ row"
      items-center
      justify-center
      px-3
      py-1
      z-0
      :class="item.key === model ? 'text-theme-white' : 'text-theme-main'"
      cursor-pointer
      @click="model = item.key as AlbumType">
      <div :class="item.icon" text-xl></div>
      <div v-if="item.key === model" ml-2 min-w-12>
        {{ item.name }}
      </div>
    </div>
  </div>
</template>
